
<app-uneeqavatar></app-uneeqavatar>

<div id="home"><img class="imgBlock" src="./assets/home-v2-update.png"></div>
<div id="opera-house"><img class="imgBlock" src="./assets/opera-house-v2.jpg"></div>
<div id="breakfast"><img class="imgBlock" src="./assets/breakfast-v2.jpg"></div>
<div id="features"><img class="imgBlock" src="./assets/features-v2.jpg"></div>